import SmallBusinessApplication from '@/application/smallBusiness/infrastructure/views/SmallBusinessApplication.vue';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import SaveAndExitSuccess from '@/application/shared/infrastructure/views/SaveAndExitSuccess.vue';
import { NavigationGuardReturn, RouteLocationGeneric, RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { checkApplicationSanity } from '@/application/shared/infrastructure/routeGuards';
import { CarrierList } from '@hfc/ui-core';
import SmallBusinessQuoteEdit from '@/application/smallBusiness/infrastructure/views/SmallBusinessQuoteEdit.vue';

export const smallBusinessRouter = {
  path: '/small-business',
  name: 'SmallBusiness',
  meta: {
    layoutClass: 'w-full',
  },
  redirect: {
    name: 'SmallBusinessApplication'
  },
  children: [{
    path: 'application',
    name: 'SmallBusinessApplication',
    component: SmallBusinessApplication,
  }, {
    path: 'application/:uuid/continue-applying',
    name: 'SmallBusinessContinueApplying',
    component: SmallBusinessQuoteEdit,
  }, {
    path: 'application/:uuid/review-challenge',
    redirect: (to: RouteLocationGeneric): RouteLocationRaw => ({
      name: 'SmallBusinessContinueApplying',
      params: { uuid: to.params.uuid }
    })
  }, {
    path: 'save-and-exit',
    name: 'SmallBusinessSaveAndExit',
    component: SaveAndExitSuccess,
    beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('small-businessSaveAndExit', 'SmallBusinessApplication'),
    props: {
      applicationType: APPLICATION_TYPES.SMALL_BUSINESS,
      carrier: CarrierList.HFC
    },
  }
  ]
};
